//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    SMS_SYSTEM_CREATE_REQUEST,
    SMS_SYSTEM_EDIT_REQUEST,
    SMS_SYSTEM_GET_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    smsSystemCreateResult,
    smsSystemGetResult,
    smsSystemEditResult
} from 'Redux/actions';

function* getSmsIntegration({ payload }) {
    try {
        let QUERY = `
            query getSmsIntegration ($id: Int!) {
                result: getSmsIntegration (id: $id) {
                    id
                    name
                    displayName
                    priority
                    isSMPP
                    active
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(smsSystemGetResult(data.result))

    } catch (exc) {
        yield put(smsSystemGetResult({ error: true }))
        ExceptionManager(exc, 'Modules/smsSystems/views/.components/createEditSmsSystem/redux/saga', 'getSmsIntegration');
    }
}

function* createSmsIntegration({ payload }) {
    try {
        let QUERY = `
            mutation createSmsIntegration ($name: String!, $displayName: String!, $active: Boolean!, $isSMPP: Boolean!) {
                result: createSmsIntegration (name: $name, displayName: $displayName, active: $active, isSMPP: $isSMPP) {
                    id
                    name
                    displayName
                    priority
                    isSMPP
                    active
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(smsSystemCreateResult(data?.result))
        } else yield put(smsSystemCreateResult())

    } catch (exc) {
        yield put(smsSystemCreateResult({ error: exc.error }))
        ExceptionManager(exc, 'Modules/smsSystems/views/.components/createEditSmsSystem/redux/saga', 'createSmsIntegration');
    }
}

function* updateSmsIntegration({ payload }) {
    try {
        let QUERY = `
            mutation updateSmsIntegration ($id: Int!, $name: String!, $displayName: String!, $priority: Int!, $active: Boolean!, $isSMPP: Boolean!) {
                result: updateSmsIntegration (id: $id, name: $name, displayName: $displayName, priority: $priority, active: $active, isSMPP: $isSMPP) {
                    id
                    name
                    displayName
                    priority
                    isSMPP
                    active
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );
        
        yield put(smsSystemEditResult(data?.result));

    } catch (exc) {
        yield put(smsSystemEditResult({ error: exc.error }))
        ExceptionManager(exc, 'Modules/smsSystems/views/.components/createEditSmsSystem/redux/saga', 'updateSmsIntegration');
    }
}

function* watchSmsIntegrationRequests() {
    yield takeEvery(SMS_SYSTEM_GET_REQUEST, getSmsIntegration);
    yield takeEvery(SMS_SYSTEM_CREATE_REQUEST, createSmsIntegration);
    yield takeEvery(SMS_SYSTEM_EDIT_REQUEST, updateSmsIntegration);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchSmsIntegrationRequests)
    ]);
}